<div #tooltipBox class="{{ visible ? 'tooltip tooltip--visible' : 'tooltip'}} flex flex-row gap-2"
  [ngClass]="['tooltip--'+position, 'tooltip--'+theme]"
  [style.left]="left + 'px'"
  [style.top]="top + 'px'">
  <label [innerHTML]="tooltip" class="whitespace-pre"></label>
  @if (shortcut) {
    <label class="neutrals-grey-05-text font-semibold">{{ shortcut }}</label>
  }
</div>